import { render } from "./AccordionContainer.vue?vue&type=template&id=767770e1&scoped=true"
const script = {}

import "./AccordionContainer.vue?vue&type=style&index=0&id=767770e1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767770e1"]])

export default __exports__